export class PermissionDefinitions {
  static readonly APP = 'admin';

  static readonly ACCOUNT_PROFILE_PAGE_VIEW = 'admin.Account.Profile.VIEW';

  static readonly CLINIC_GROUP_DETAIL_FORM_VIEW = 'admin.ClinicGroup.Detail.VIEW';
  static readonly CLINIC_GROUP_DETAIL_FORM_WRITE = 'admin.ClinicGroup.Detail.WRITE';
  static readonly CLINIC_GROUP_DETAIL_PRACTICES_VIEW = 'admin.ClinicGroup.Detail.Practices_VIEW';
  static readonly CLINIC_GROUP_DETAIL_PRACTICES_WRITE = 'admin.ClinicGroup.Detail.Practices_WRITE';
  static readonly CLINIC_GROUP_DETAIL_USERS_VIEW = 'admin.ClinicGroup.Detail.Users_VIEW';
  static readonly CLINIC_GROUP_DETAIL_USERS_WRITE = 'admin.ClinicGroup.Detail.Users_WRITE';
  static readonly CLINIC_GROUP_USERS_ASSIGN_WEB_ADJUSTMENT_VIEW =
    'admin.ClinicGroup.Users.AssignWebAdjustment_VIEW';
  static readonly TREATMENT_ADJUST_ONLINE_ADJUST = 'iq.Treatment.Adjust.ONLINE_ADJUST';

  static readonly CLINIC_GROUP_PRACTICE_DETAIL_DEVICES_VIEW = 'admin.ClinicGroup.PracticeDetail.Devices_VIEW';
  static readonly CLINIC_GROUP_PRACTICE_DETAIL_DEVICES_WRITE = 'admin.ClinicGroup.PracticeDetail.Devices_WRITE';
}
